// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__SZ0Hc","employee-header-item":"Header_employee-header-item__eCgrT"};